import { Badge } from "@/components/ui/badge";
import moment from "moment";
import getUnidade from "@/utils/getUnidade";
import obterRespostaByArray from "@/utils/obterRespostaByArray";
import getServico from "@/utils/getServico";
import { ScrollArea } from "@/components/ui/scroll-area";
import { TooltipEasy } from "@/components/tooltipEasy";
import { User } from "lucide-react";
import { ItemEquipe } from "./ItemEquipe";
import getPrazo from "@/utils/getPrazo";
import { EmptyData } from "./EmptyData";
import { FilterCard } from "../filterCard";
import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";

export function CardFases({ label, solicitacoes = [], unidadeId }) {
  const total_andamento = solicitacoes ? solicitacoes.length : 0

  const isConcluidos = label === "Concluídos"
  const data_solicitacoes = isConcluidos
    ? [...solicitacoes].sort((a, b) => new Date(b.finalizado_data) - new Date(a.finalizado_data))
    : solicitacoes;

  const [visibleCount, setVisibleCount] = useState(10);

  const { ref, inView } = useInView({
    triggerOnce: false,
    threshold: 0.5,
  });

  useEffect(() => {
    if (inView) {
      setVisibleCount((prev) => Math.min(prev + 10, data_solicitacoes.length));
    }
  }, [inView, data_solicitacoes.length]);

  if (solicitacoes?.length === 0) return <div className="hidden" />;

  return (
    <div className="relative bg-[#f3f4f5] rounded-md min-h-[540px] border border-[#e2e8f0]">
      <div className="flex items-center gap-1 absolute top-2 right-2">
        <TooltipEasy content="Quantidade de registros"><Badge className="bg-[#717171] text-white">{total_andamento} <User /></Badge></TooltipEasy>
      </div>
      <div className="py-3 p-4">
        <div className="flex items-center gap-3">
          <p className="font-bold text-lg">{label}</p>
          {isConcluidos && <FilterCard />}
        </div>
      </div>

      <ScrollArea className="h-[480px] px-4">
        <div className="flex flex-col gap-2">
          {solicitacoes?.length === 0 && <EmptyData />}
          {data_solicitacoes.slice(0, visibleCount).map((item) => (
            <ItemEquipe
              key={item._id}
              id={item._id}
              tempo_ate_agora={moment(item.createdAt).fromNow()}
              nome_aluno={obterRespostaByArray(item.solicitacao, "nome_completo")}
              servico={getServico(item.setor, item.servico)}
              atendente={item.atendente?.nome}
              unidade={getUnidade(item.unidade)}
              prazo={getPrazo(item.setor, item.servico)}
              createdAt={item.createdAt}
              label={label}
              finalizado_data={item.finalizado_data}
              unidadeId={unidadeId}
            />
          ))}
          {visibleCount < data_solicitacoes.length && (
            <div ref={ref} className="h-10" />
          )}
        </div>
      </ScrollArea>
    </div>
  );
}